import { configureStore } from '@reduxjs/toolkit';
// We will import reducers here later
import authReducer from '../features/auth/authSlice';
import requisitionReducer from '../features/requisitions/requisitionSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    requisitions: requisitionReducer,
    // Add other reducers here as you create them
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {auth: AuthState, requisitions: RequisitionsState, ...}
export type AppDispatch = typeof store.dispatch;
